import { render, staticRenderFns } from "./ImportantCell.vue?vue&type=template&id=eef62f9a&scoped=true&lang=pug&"
import script from "./ImportantCell.vue?vue&type=script&lang=ts&"
export * from "./ImportantCell.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantCell.vue?vue&type=style&index=0&id=eef62f9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef62f9a",
  null
  
)

export default component.exports